module.exports = __webpack_public_path__ + "img/login-bg.bb135a79.svg";